import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import * as historyUtils from "../../../utils/historyUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_HISTORY } from "./abstract/historyAbstract";

const _action = `${ACTION_PREFIX_HISTORY}_undo`;
const _header = `Revert to -`;

export const historyUndo = (time, register) => {
  const { root, payload } = historyUndoLogic(time, register);

  logger.logAction(_action, payload, ACTION_PREFIX_HISTORY);

  return { root, info: payload };
};

//--------------------------------------------------------------------------------

export const historyUndoLogic = (time, register) => {
  const eventLast = historyUtils.getLastEvent(register);
  const eventCurrent = historyUtils.getHistoryEvent(time, register);

  if (eventLast.name.startsWith(_header)) {
    if (eventLast.time === eventCurrent.time) {
      return undo(time, register, eventCurrent);
    }

    return hasUndoToken(time, register, eventCurrent, eventLast);
  }

  return hasNoUndoToken(time, register, eventCurrent);
};

const hasNoUndoToken = (time, register, record) => {
  const _eventNext = historyUtils.getNextHistoryEvent(time, register);

  const root = historyUtils.getHistoryState(record.time);

  if (_eventNext) {
    historyUtils.markRecordsAsInactiveFrom(record.time, register);
    return { root, payload: generatePayload(record.time, record) };
  }

  return { root, payload: generatePayloadIndifferent(record) };
};

const hasUndoToken = (time, register, record, recordLast) => {
  historyUtils.markRecordsActiveFrom(recordLast.rewind, register);
  historyUtils.deleteEventLast(register);

  return hasNoUndoToken(time, register, record);
};

const undo = (time, register, record) => {
  const root = historyUtils.getHistoryState(time);

  historyUtils.markRecordsActiveFrom(record.rewind, register);
  historyUtils.deleteEventLast(register);

  return { root, payload: generatePayloadIndifferent(record) };
};

//--------------------------------------------------------------------------------

const generatePayload = (time, record) => {
  const _payload = {
    group: ActionGroupTypes.REVERT,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: `${_header} ${record.index}`,
    description: `Load state from ${record.index}.`,
    rewind: time,
    idFunction: record.idFunction
  };

  return _payload;
};

const generatePayloadIndifferent = (record) => {
  const _payload = {
    group: ActionGroupTypes.REVERT,
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    idFunction: record.idFunction
  };

  return _payload;
};
